import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import BaseModal from '../types/Base';
import {_openModal, _removeModal} from '../../../store';
import axiosInstance from '../../../utils/axios';
import {_setNotification} from '../../../reducers/headerNotification';
import {formatter} from '../../../utils/utils';
import {PORTAL_NAME} from '../../../../config.json';
import {Button, DescriptiveText, Row, TextArea} from '../../../index';

const FeedbackModal = ({content, removeModal, openModal, setNotification, session, product}) => {
  const {title = 'Feedback', copy, placeholder, successMessage = 'Thank you for your feedback.', trackingID} = content;
  const [message, setMessage] = React.useState('');
  const [processing, setProcessing] = React.useState(false);
  const body = React.useMemo(() => {
    if (!copy) {
      let contact;
      const brand = session && session.profile && session.profile.brand || product.brand;
      if (PORTAL_NAME === 'advisor') {
        contact = {
          email: brand.advisorCSEmail,
          phone: brand.advisorCSPhone,
        };
      } else if (PORTAL_NAME === 'investor') {
        contact = {
          email: brand.investorCSEmail,
          phone: brand.investorCSPhone,
        };
      }

      return 'We welcome your feedback. Please let us know how we are doing. Submit a message below or contact us at '
        + contact.email
        + ' or <a id="feedbackModal-phoneNumber" href="tel:'
        + contact.phone
        + '" class="no-wrap">'
        + formatter('phone')(contact.phone)
        + '</a>.';
    }
    return copy;
  }, [copy]);

  const executeAction = e => {
    e.preventDefault();
    setProcessing(true);
    return axiosInstance.post('/user/feedback', {url: window.location.href, type: 'Comment', message, data: '{}', trackingID})
      .then(() => {
        setNotification({message: successMessage});
        removeModal(content);
        setProcessing(false);
      })
      .catch(err => {removeModal(content); openModal({type: 'Error', title, err});});
  };

  return <BaseModal onClose={() => removeModal(content)} title={title}>
    <form id={'feedbackForm'} onSubmit={executeAction}>
      <DescriptiveText>
        <div dangerouslySetInnerHTML={{__html: body}}/>
      </DescriptiveText>
      <TextArea
        id={'message'}
        height={'200px'}
        dataPoint={{name: 'message', value: message}}
        placeholder={placeholder}
        required={true}
        onChange={(name, value) => setMessage(value)}
      />
      <Row>
        <Button width={'auto'}
                importance={'secondary'}
                size={'md'}
                label={'Cancel'}
                action={() => removeModal(content)}
                disabled={processing}/>
        <Button width={'auto'} importance={'primary'} size={'md'} label={'Submit'} action={'SUBMIT'} processing={processing}/>
      </Row>
    </form>
  </BaseModal>;
};

const mapStateToProps = state => ({
  session: state.session,
  product: state.product,
});

const mapDispatchToProps = dispatch => ({
  removeModal: modal => dispatch(_removeModal(modal)),
  openModal: modal => dispatch(_openModal(modal)),
  setNotification: note => dispatch(_setNotification(note)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FeedbackModal);

FeedbackModal.propTypes = {
  setNotification: PropTypes.func.isRequired,
  session: PropTypes.object,
  product: PropTypes.object.isRequired,
  removeModal: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  content: PropTypes.shape({
    title: PropTypes.string,
    /**
     * Default Message to populate input with
     */
    copy: PropTypes.string,
    /**
     * Placeholder for input
     */
    placeholder: PropTypes.string,
    /**
     * Message shown upon successful feedback submission
     */
    successMessage: PropTypes.string,
    /**
     * Tracking ID (from a tracking component) to associate with the feedback
     */
    trackingID: PropTypes.number,
  }).isRequired,
};
